import type { FieldValues, Path } from "react-hook-form";

/**
 * ADV-787: field-config types + helpers for the EntityForm scaffold. Split into
 * a non-component module so the scaffold file (entity-form.tsx) only exports a
 * component (react-refresh) and so per-entity config files import from here.
 */

type EntityFieldOption = { value: string; label: string };

export type EntityFieldConfig<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  control:
    | "text"
    | "email"
    | "tel"
    | "number"
    | "textarea"
    | "select"
    | "switch";
  /** Required for `select`. Use the entity's exported enum array via enumOptions(). */
  options?: EntityFieldOption[];
  placeholder?: string;
  /** Adds a required asterisk + an RHF required rule. */
  required?: boolean;
  description?: string;
  /** Placeholder option label for an unselected, non-required select. */
  emptyOptionLabel?: string;
};

/** Map a readonly enum array to {value,label} select options, Title-Casing labels. */
export function enumOptions(
  values: readonly string[],
  labels?: Record<string, string>,
): EntityFieldOption[] {
  return values.map((v) => ({ value: v, label: labels?.[v] ?? titleCase(v) }));
}

function titleCase(s: string): string {
  return s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
